import { useCallback, useEffect, useRef, useState } from 'react'

import { StartVirtualCandidateSessionRequest } from 'src/services/backend/VirtualCandidateService'
import {
    INITIAL_STATE,
    VirtualCandidateSessionController,
    VirtualCandidateState,
} from 'src/services/virtual-candidate/VirtualCandidateSessionController'

/** React state for one virtual candidate run; closing or unmounting ends it. */
export function useVirtualCandidateSession() {
    const [state, setState] = useState<VirtualCandidateState>(INITIAL_STATE)
    const controllerRef = useRef<VirtualCandidateSessionController>()
    if (!controllerRef.current) {
        controllerRef.current = new VirtualCandidateSessionController(setState)
    }
    const controller = controllerRef.current

    useEffect(() => () => controller.close(), [controller])

    const start = useCallback(
        (buildRequest: () => Promise<StartVirtualCandidateSessionRequest>) =>
            controller.start(buildRequest),
        [controller]
    )
    const endInterview = useCallback(() => void controller.endInterview(), [controller])
    const close = useCallback(() => controller.close(), [controller])
    const reconnectAudio = useCallback(() => controller.reconnectAudio(), [controller])
    const disconnectAudio = useCallback(() => controller.disconnectAudio(), [controller])

    return { state, start, endInterview, close, reconnectAudio, disconnectAudio }
}
